import { useUpsertSheetRowMutation } from '../../../../recoil/mutations/upsertSheetRowMutation'
import type { RSheetsCellInputRenderTypeArgument } from '../rSheetsCellInputRenderTypeArgument'
import { DatePicker } from './DatePicker'
import { RSheetsInputCellWrapper } from './InputCellWrapper'

export function RSheetsCellDateInput({
  recordNode,
  column,
  rowIndex,
  innerRowIndex,
  finishEditMode,
  boxStyle,
  compiledConfig,
  ability,
  query,
}: RSheetsCellInputRenderTypeArgument) {
  const columnOnChange = useUpsertSheetRowMutation(recordNode, ability, query)
  const value = recordNode === undefined ? undefined : column.value(recordNode)
  const date = typeof value === 'string' ? value : undefined

  return RSheetsInputCellWrapper(
    {
      onChangeFixed() {
        // eslint-disable-next-line sonarjs/todo-tag
        // TODO: 単純にキャンセルとするで良いか？
      },
      finishEditMode,
    },
    () => (
      <div
        style={{
          ...boxStyle,
          padding: '9px 9px',
          backgroundColor: 'white',
        }}
      >
        <DatePicker
          value={date}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises,@typescript-eslint/strict-void-return
          onChange={async (value) => {
            await columnOnChange({
              value: value?.format('YYYY-MM-DD') ?? null,
              rowIndex,
              innerRowIndex,
              column,
            })
            finishEditMode()
          }}
          onClose={() => {
            finishEditMode()
          }}
        />
      </div>
    ),
  )
}
